module.exports = __webpack_public_path__ + "img/gallery-image-30.b3e545c7.jpg";